import React from "react";
import styled from "styled-components";
import AppHeader from "./AppHeader";
import { MdSecurity, MdHistory, MdBusiness, MdContactSupport } from "react-icons/md";

const PageContainer = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 50px;
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 30px auto;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  font-family: 'Inter', -apple-system, sans-serif;
  color: #2d3748;
`;

const Title = styled.h1`
  color: #1a202c;
  font-size: 2.2rem;
  margin-bottom: 10px;
  text-align: center;
`;

const MetaInfo = styled.div`
  text-align: center;
  color: #718096;
  font-size: 14px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

const SectionHeader = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a73e8;
  font-size: 1.4rem;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  
  li {
    position: relative;
    padding-left: 25px;
    margin-bottom: 15px;
    line-height: 1.6;

    &::before {
      content: "•";
      color: #1a73e8;
      font-weight: bold;
      position: absolute;
      left: 0;
      font-size: 20px;
    }
  }

  strong {
    color: #1a202c;
  }
`;

const HighlightCard = styled.div`
  background: #f0f7ff;
  border-left: 4px solid #1a73e8;
  padding: 20px;
  border-radius: 8px;
  margin-top: 10px;
`;

const PrivacyPolicy = () => {
  return (
    <PageContainer>
      <AppHeader />
      <ContentWrapper>
        <Title>Privacy Policy</Title>
        <MetaInfo>
          <span><strong>Effective Date:</strong> January 30, 2026</span>
          <span><strong>Entity:</strong> Avaami Technologies Pvt. Ltd.</span>
          <p>This policy explains how we handle data for our Business Owners, Employees, and Public Users.</p>
        </MetaInfo>

        <Section>
          <SectionHeader><MdBusiness /> A. Information We Collect</SectionHeader>
          <InfoList>
            <li><strong>Profile Data:</strong> Names, mobile numbers, business addresses, and GST details (for business owners).</li>
            <li><strong>Professional Data:</strong> Skills, experience, and job postings for laborers and employees.</li>
          </InfoList>
          {/* Use standard text for common elements unless complex math/logic is needed */}
          <InfoList>
            <li><strong>Interaction Data:</strong> Messages, group discussions, and "Repost/Comment" activities.</li>
            <li><strong>Call Data:</strong> When the "Call" button is used, we may log the timestamp for business analytics.</li>
          </InfoList>
        </Section>

        <Section>
          <SectionHeader><MdHistory /> B. Purpose of Processing</SectionHeader>
          <InfoList>
            <li>To facilitate B2B and B2C connections.</li>
            <li>To enable job discovery and recruitment for skilled labor.</li>
            <li>To provide targeted business analytics to page owners.</li>
          </InfoList>
        </Section>

        <Section>
          <SectionHeader><MdSecurity /> C. Data Security</SectionHeader>
          <HighlightCard>
            We utilize <strong>Google Cloud Identity & Access Management (IAM)</strong> and encryption at rest to ensure that your business secrets and personal details are protected from unauthorized access.
          </HighlightCard>
        </Section>

        <Section>
          <SectionHeader><MdContactSupport /> D. Your Rights</SectionHeader>
          <p>Under the <strong>DPDP Act</strong>, users have the right to Access, Correct, or Erase their data.</p>
          <p style={{marginTop: '15px'}}>
            To exercise these rights, contact our Grievance Officer at: <br/>
            <a href="mailto:support@avaami.com" style={{color: '#1a73e8', fontWeight: 'bold', textDecoration: 'none'}}>
              support@avaami.com
            </a>
          </p>
        </Section>
      </ContentWrapper>
    </PageContainer>
  );
};

export default PrivacyPolicy;